<template>
  <div>
    <div class="header" v-if="!range">
      <span class="goback" @click="goBack"><img src="../../../static/images/goback.png"></span><span class="title">学习数据</span><span class="range" @click="changeRange">统计范围
        <img src="../../../static/images/rangedown.png">
      </span>
    </div>
    <div class="report-wrapper" v-if='data'>
      <p class="report_name">{{data.course_name}}</p>
      <div class="info_detail">
        <img :src="data.user_info.head_portrait">
        <p class="user_name">{{data.user_info.name}}</p>
        <div class="statistics">
          <div><p>
            <span>学习总时长</span><span class="learn_num"><b>{{data.course_total.current_study_duration_total}}</b>小时</span>
            <span class="total_time">累计时长{{data.course_total.study_duration_total}}小时</span>
          </p></div>
          <span class="borders"></span>
          <div><p>
            <span>学习总天数</span><span class="learn_num"><b>{{data.course_total.current_study_day_total}}</b>天</span>
            <span class="total_time">累计天数{{data.course_total.study_day_total}}天</span>
          </p></div>
          <span class="borders"></span>
          <div><p>
            <span>课件完成数</span><span class="learn_num"><b>{{data.course_total.current_course_finish_total}}</b>个</span><span>累计完成{{data.course_total.course_finish_total}}个</span>
          </p></div>
        </div>
      </div>
      <p class="unaccomplished"><img src="../../../static/images/havent.png">你还有学习内容未完成，请下滑查看</p>
      <div class="live_detail" v-if="data.live.effective_attendance.total != 0">
        <p class="live_title">
          <span class="icon"><img src="../../../static/images/live.png">直播
            <span class="supplementary">周期内共{{data.live.attendance.total}}节直播,出勤{{data.live.attendance.attendance}}节</span>
          </span>
          <span v-if='data.live.attendance.total != 0' class="godetail" @click='goToLive'>详情<img src="../../../static/images/detail.png"></span>
        </p>
        <div class="partition_statistics">
          <div class="canvas">
            <p>课程完成数</p>
            <p class="finish_num">{{data.live.attendance.current_attendance}}/{{data.live.attendance.current_total}}</p>
            <p>累计完成{{data.live.effective_attendance.effective_attendance}}/{{data.live.effective_attendance.total}}</p>
          </div>
          <div class="canvas">
            <p>直播观看时长</p>
            <p class="finish_num">{{data.live.effective_watch.effective_watch}}<span class="hours">小时</span></p>
            <p>累计时长{{data.live.effective_watch.total}}时</p>
          </div>
          <div class="canvas">
            <p>回放净观看时长</p>
            <p class="finish_num">{{data.playback.current_duration}}<span class="hours">小时</span></p>
            <p>累计时长{{data.playback.duration}}时</p>
          </div>
        </div>
        <div class="introduce"><span></span>课程完成：直播观看达45分钟或回放观看达50%</div>
      </div>
      <div class="video_detail" v-if="data.video.grand_total != 0">
        <p class="live_title"><span class="icon"><img src="../../../static/images/shipin.png">视频</span>
          <span class="godetail" @click='goVideo'>详情<img src="../../../static/images/detail.png"></span>
        </p>
        <div class="partition_statistics">
          <div class="canvas">
            <p class="cumulative_duration">完成数</p>
            <p class="finish_num">{{data.video.current_finish_total}}/{{data.video.current_grand_total}}</p>
            <p>累计完成{{data.video.finish_total}}/{{data.video.grand_total}}</p>
          </div>
          <div class="canvas">
            <p class="cumulative_duration">观看时长</p>
            <p class="finish_num">{{data.video.current_duration}}<span class="hours">小时</span></p>
            <p>累计时长{{data.video.duration}}小时</p>
          </div>
          <div class="canvas" style="opacity: 0;"></div>
        </div>
      </div>
      <div class="homework_detail" v-if="data.homework.grand_total != 0">
        <p class="live_title">
          <span class="icon"><img src="../../../static/images/homework.png">作业<span v-if="ua" class="supplementary">可登录学习APP及时处理未完成作业</span></span>
          <span v-if="isApp" class="godetail" @click='goHomeWork'>详情<img src="../../../static/images/detail.png"></span>
        </p>
        <div class="partition_statistics">
          <div class="canvas">
            <p>完成数</p>
            <p class="finish_num">{{data.homework.current_finish_total}}/{{data.homework.current_grand_total}}</p>
            <p>累计完成{{data.homework.finish_total}}/{{data.homework.grand_total}}</p>
          </div>
          <div class="canvas">
            <p>正确率</p>
            <p class="finish_num">{{data.homework.current_rate}}</p>
            <p>历史正确率{{data.homework.rate}}</p>
          </div>
          <div class="canvas">
            <p>平均分</p>
            <p class="finish_num">{{data.homework.current_avg}}<span class="hours">分</span></p>
            <p>历史平均分{{data.homework.avg}}</p>
          </div>
        </div>
      </div>
      <div class="mock_detail" v-if="data.simulate.grand_total != 0">
        <p class="live_title">
          <span class="icon"><img src="../../../static/images/mock.png">模考</span>
          <span v-if="isApp" class="godetail" @click='goMock'>详情<img src="../../../static/images/detail.png"></span>
        </p>
        <div class="partition_statistics">
          <div class="canvas">
            <p>完成数</p>
            <p class="finish_num">{{data.simulate.finish}}/{{data.simulate.finish_total}}</p>
            <p>累计完成{{data.simulate.grand_finish}}/{{data.simulate.grand_total}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="screen_wrapper" v-if="range">
      <div class="screen_header">
        <span class="goback" @click="goBack"><img src="../../../static/images/goback.png"></span><span class="title">学习数据</span><span class="range" @click="changeRange">统计范围
          <img src="../../../static/images/rangeup.png">
        </span>
      </div>
      <div class="screen_option">
        <p class="screen_time">统计时间</p>
        <van-cell v-if="bianliang" @click="show = true" :value="date" :title="!bianliang ? data.order_created_at.slice(0, 11).replace(/-/g, '.') + '- 至今' : ''" />
        <van-cell v-else :title="data.order_created_at.slice(0, 11).replace(/-/g, '.') + '- 至今'"  @click="show = true" />
        <van-calendar title="请选择日期" ref="calendar" v-model="show" type="range" :min-date='minDate' :max-date='maxDate' @confirm="onConfirm" position="top" :show-mark="false" color="#e60012" @select="onSelect" />
        <p class="screen_time">统计课程<span class="choose_all">全选<input type="checkbox" v-model="ischoose" @click="checkAll(ischeck)"></span></p>
        <div class="check_options">
          <p v-for='(i, index) in packlist' :key='index'><span class="radio-name">{{i.value}}</span>
            <label :for="'radio' + index" class="radio-circle" :class="{'radio-check': i.check }"></label><input :id="'radio' + index" type="checkbox" v-model="i.check" @change='pack(i.id)'>
          </p>
        </div>
        <p class="screen_btn">
          <span @click="onreset">重置</span><span class="determine" @click="onclose">确定</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import "vant/lib/calendar/style";
export default {
  data() {
    return {
      data: '',
      ua: navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
      isAndroid: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isApp: navigator.userAgent.toLowerCase().indexOf('zaixianketang') != -1 ? true : false,
      sso: '',
      date: '',
      show: false,
      range: false,
      packlist: [],
      ischeck: true,
      ischoose: false,
      timepick: false,
      tongji_lesson: false,
      minDate: new Date(1999, 12, 1),
      maxDate: new Date(),
      hideHeader: this.$route.query.hideHeader,
      packarr: [],
      start_time: '',
      end_time: '',
      bianliang: false
    };
  },
  mounted() {
    if (this.hideHeader == 1) {
      this.$router.push({
        path: "/reportscreen",
        query: {
          sn: this.$route.query.sn
        }
      })
    }
    this.getreport()
    this.getlearnpack();
  },
  created(){
      let that = this;
      setTimeout(() => {
        that.$nextTick(function(){
          if (this.$refs && this.$refs.calendar) {
            // 选中区间的日期      
            $(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start')).find('span').remove();
            $(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end')).find('span').remove();
            let startText = this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start').innerText;
            let endText = this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end').innerText;
            this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start').insertAdjacentHTML('afterbegin', `<span>${parseInt(startText.substr(0, startText.indexOf('开')))}</span>`);
            this.addClass(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start'), 'add');
            this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end').insertAdjacentHTML('afterbegin', `<span>${parseInt(endText.substr(0, endText.indexOf('结')))}</span>`);
            this.addClass(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end'), 'add');   
          }  
        });
      }, 100);
  },
  methods: {
    changeRange(){
      this.range = !this.range;
    },
    getlearnpack () {
      this.$api.GETDETAIL({
        system_order_num: this.$route.query.sn,
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      }).then((res) => {
        if (res.code == 0) {
          for (let i in res.data.list) {
            for (let j in res.data.list[i].list) {
              for (let k in res.data.list[i].list[j].list) {
                var obj = {
                  value: res.data.list[i].list[j].list[k].name,
                  check: false,
                  id: res.data.list[i].list[j].list[k].id
                }
                this.packlist.push(obj)
              }
            }
          }
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    },
    checkAll (val) {
      if (val) {
        this.packlist.forEach(function (item) {
          item.check = true
        })
        this.ischeck = false
      } else {
        this.packlist.forEach(function (item) {
          item.check = false
        })
        this.ischeck = true
      }
    },
    goBack () {
      if (this.isAndroid) {
        window.androidJS.goBack();
      } else if (this.isiOS) {
        var action = 'goBack'
        window.webkit.messageHandlers.jsCallOCFunction.postMessage('goBack');
      }
    },
    goToLive() {
      var data = {
        system_order_num: this.$route.query.sn,
        sso_id: this.sso.user_id,
        business_id: this.$route.query.report_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToLive'
      }
      if (this.ua) {
        this.$router.push({
          path: "/attendance",
          query: {
            ticket: this.$route.query.ticket,
            sn: this.$route.query.sn,
            bc_id: this.$route.query.report_id,
            st: new Date(this.data.course_total.study_start_date).getTime()/1000,
            et: new Date(this.data.course_total.study_end_date).getTime()/1000,
            type: 1
          }
        });
      } else if (this.isAndroid) {
        window.androidJS.goToLive(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    goVideo () {
      var data = {
        system_order_num: this.$route.query.sn,
        sso_id: this.sso.user_id,
        business_id: this.$route.query.report_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToVideo'
      }
      if (this.ua) {
        this.$router.push({
          path: "/attendance",
          query: {
            ticket: this.$route.query.ticket,
            sn: this.$route.query.sn,
            bc_id: this.$route.query.report_id,
            st: new Date(this.data.course_total.study_start_date).getTime()/1000,
            et: new Date(this.data.course_total.study_end_date).getTime()/1000,
            type: 2
          }
        });
      } else if (this.isAndroid) {
        window.androidJS.goToVideo(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    goHomeWork() {
      var data = {
        system_order_num: this.$route.query.sn,
        sso_id: this.sso.user_id,
        business_id: this.$route.query.report_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToHomework'
      }
      if (this.isAndroid) {
        window.androidJS.goToHomework(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    goMock () {
      var data = {
        system_order_num: this.$route.query.sn,
        sso_id: this.sso.user_id,
        business_id: this.$route.query.report_id,
        course_name: this.data.course_name,
        start_time: this.data.start_time,
        end_time: this.data.end_time,
        action: 'goToMock'
      }
      if (this.isAndroid) {
        window.androidJS.goToMock(JSON.stringify(data));
      } else if (this.isiOS) {
        window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(data));
      }
    },
    wx_homework () {
      if (this.ua) {
        Toast("可登录学习APP及时处理未完成作业");
      }
    },
    pack (val) {
      let index = this.packarr.indexOf(val)
      if (index == -1) {
        this.packarr.push(val)
      } else {
        this.packarr.splice(index, 1)
      }
      console.log(this.packarr)
    },
    getreport (start_time, end_time, packages) {
      this.$api.COURSEDETAIL({
        "offcn-ticket": this.$route.query.ticket,
        business_id: this.$route.query.business_id,
        system_order_num: this.$route.query.sn,
        start_date: start_time,
        end_date: end_time,
        packages: packages
      }).then((res) => {
        if (res.code == 0) {
          this.data = res.data;
          this.sso = res.sso
          var share = {
            share_qr: res.data.share_qr,
            share_title: res.data.share_title,
            share_note: res.data.share_note,
            share_content: res.data.share_content,
            action: 'getShare'
          }
          if (this.isAndroid) {
            window.androidJS.getShare(JSON.stringify(share));
          } else if (this.isiOS) {
            window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(share));
          }
        }
      })
    },
    formatDate(date) {
      return `${date.getFullYear()}.${this.addZero(date.getMonth() + 1)}.${this.addZero(date.getDate())}`;
    },
    formatDateTime(date) {
      return `${date.getFullYear()}-${this.addZero(date.getMonth() + 1)}-${this.addZero(date.getDate())}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.timepick = false
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      this.start_time = start
      this.end_time = end
      this.bianliang = true
    },
    formatTime (timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minutes = time.getMinutes();
      let seconds = time.getSeconds();
      return year + '-' + this.addZero(month) + '-' + this.addZero(date);
    },
    addZero (m) {
      return m < 10 ? '0' + m : m
    },
    onSelect(date) {
      let that = this;
      const [start, end] = date;
      let obj = this.getWeek(this.formatTime(start && start.getTime()), this.formatTime(end && end.getTime()), 0); // 周日
      let obj1 = this.getWeek(this.formatTime(start && start.getTime()), this.formatTime(end && end.getTime()), 6); // 周六
      let arr1 = [];
      let arr2 = [];
      if (start && end) {
        that.$nextTick(function(){
          obj && obj.dateArr.forEach((item) => {
           arr1.push(item.substr(item.lastIndexOf("-") + 1));
          });
          obj1 && obj1.dateArr.forEach((item) => {
           arr2.push(item.substr(item.lastIndexOf("-") + 1));
          });
          // 选中区间的日期
          $(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start')).find('span').remove();
          $(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end')).find('span').remove();
          let startText = this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start').innerText;
          let endText = this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end').innerText;
          this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start').insertAdjacentHTML('afterbegin', `<span>${parseInt(startText.substr(0, startText.indexOf('开')))}</span>`);
          this.addClass(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--start'), 'add');
          this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end').insertAdjacentHTML('afterbegin', `<span>${parseInt(endText.substr(0, endText.indexOf('结')))}</span>`);
          this.addClass(this.$refs.calendar.$refs.body.querySelector('.van-calendar__day--end'), 'add');
          let arr = this.$refs.calendar.$refs.body.querySelectorAll('.van-calendar__day--middle');
          arr.forEach((item)=> {
            if (item.innerText.indexOf('\n') > -1) { // 删选出日期防止是中间日期被当做开始或者结束日期过
              item.innerText = item.innerText.substr(0, item.innerText.indexOf('\n'));
            }
            if (item.innerText == 30 || item.innerText == 31) { // 每月月末
              this.addClass(item, 'saturday');
            }
            if (item.innerText == 1) { // 每月月初
              this.addClass(item, 'sunday');
            }
            this.delAero(arr1).forEach((j) => { // 每周日
              if(item.innerText == j) { // 月末不是周日
                this.addClass(item, 'sunday');
                if(j == 30 || j== 31){
                  this.addClass(item, 'sundayEnd');
                }
              }
            }); 
            this.delAero(arr2).forEach((j) => { // 每周六
              if(item.innerText == j) {
                this.addClass(item, 'saturday');
              }
            });
          });        
        });       
      }
    },
    // 去除日历时间不足10天数据前的补0
    delAero(arr){
      let a = [];
      arr.forEach(item => {
        if (item && item.substr(0, 1) == 0 ){
          a.push(item.substr(1));
        } else {
          a.push(item);
        }
      });
      return a;
    },
    // 获取时间段内所有指定日期
    getWeek (begin, end, weekNum){
      var dateArr = new Array();
      let newArr = new Array();  // 时间段的每天时间
      var stimeArr = begin.split("-");//=>["2018", "01", "01"]
      var etimeArr = end.split("-");//=>["2018", "01", "30"]
      // console.log(stimeArr,etimeArr);
      
      var stoday = new Date();
      stoday.setUTCFullYear(stimeArr[0], stimeArr[1]-1, stimeArr[2]);
      var etoday = new Date();
      etoday.setUTCFullYear(etimeArr[0], etimeArr[1]-1, etimeArr[2]);

      var unixDb = stoday.getTime();//开始时间的毫秒数
      var unixDe = etoday.getTime();//结束时间的毫秒数

      for (var k = unixDb; k <= unixDe;) {
        let needJudgeDate = this.msToDate(parseInt(k)).withoutTime;
        newArr.push(new Date(needJudgeDate).getDay())
        //  console.log(needJudgeDate,new Date(needJudgeDate).getDay(),newArr);
        
        //不加这个if判断直接push的话就是已知时间段内的所有日期
        if (new Date(needJudgeDate).getDay() == weekNum) {
            dateArr.push(needJudgeDate);
        }
          k = k + 24*60*60*1000;
      }
      // if(newArr[0] > 1){
      //   let n = (newArr[0] - 1)*24*60*60*1000
      //   let h = this.msToDate(stoday.getTime()-n).withoutTime
      //   console.log(this.msToDate(stoday.getTime()-n).withoutTime);
      //   dateArr.unshift(h)
      // }
      return {newArr,dateArr};
    },
    msToDate (msec) {
      let datetime = new Date(msec);
      let year = datetime.getFullYear();
      let month = datetime.getMonth();
      let date = datetime.getDate();
      let hour = datetime.getHours();
      let minute = datetime.getMinutes();
      let second = datetime.getSeconds();

      let result1 = year + '-' + 
                  ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) + 
                  '-' + 
                  ((date + 1) < 10 ? '0' + date : date) + 
                  ' ' + 
                  ((hour + 1) < 10 ? '0' + hour : hour) +
                  ':' + 
                  ((minute + 1) < 10 ? '0' + minute : minute) + 
                  ':' + 
                  ((second + 1) < 10 ? '0' + second : second);

      let result2 = year + '-' + 
                  ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) + 
                  '-' + ((date + 1) < 11 ? '0' + date : date);

      let result = {
          hasTime: result1,
          withoutTime: result2
      };
      return result;
    },
    addClass(el, className) {
    // 通过空格将原有类名字符串组装成数组
    let newClass = el.className.split(' ')
    newClass.push(className)
    // 添加完毕后 通过空格将数组组装为字符串
    el.className = newClass.join(' ')
    },
    onreset () {
      this.date = '选择日期区间'
      this.ischoose = false
      this.checkAll()
    },
    onclose () {
      this.range = false
      if (this.start_time) {
        this.getreport(this.formatDateTime(this.start_time), this.formatDateTime(this.end_time), this.packarr)
      } else {
        this.getreport(this.formatDateTime(new Date(this.data.order_created_at)), '', this.packarr)
      }
    },
    changereset () {
      this.checkAll()
    },
    onsure () {
      this.tongji_lesson = false
      this.getreport('', '', this.packarr)
    }
  }
};
</script>

<style lang="less" scoped>
.van-cell {
  height: 90px;
  line-height: 90px;
  font-size: 30px;
  border-bottom: 1px solid #e6e6e6;
  padding-left: 30px;
  font-weight: bold;
  .van-cell__title {
    color: #333333;
  }
}
/deep/.van-calendar__popup {
  height: 70%;
}
/deep/.van-calendar__popup .van-popup__close-icon {
  top: 8px;
  left: 24px;
}
/deep/.van-icon-cross:before {
  left: 0;
  width: 12px;
  height: 28px;
  content: '';
  background: url(./static/images/goback.png) no-repeat;
  background-size: 100%;
}
.header {
  position: relative;
  text-align: center;
  height: 92px;
  line-height: 92px;
  font-size: 32px;
  background: #ffffff;
  .goback {
    position: absolute;
    left: 34px;
    img {
      width: 14px;
      height: 28px;
    }
  }
  .title {
    font-weight: bold;
    color: #333333;
  }
  .range {
    position: absolute;
    right: 26px;
    font-size: 28px;
    color: #666666;
    img {
      width: 22px;
      height: 22px;
      margin-left: 14px;
    }
  }
}
.report-wrapper {
  width: 100%;
  min-height: 100%;
  padding: 30px;
  background: url('./static/images/top_back.png') no-repeat;
  background-size: 100%;
  color: #333333;
  background-color: #F3F3F3;
  .time_range, .report_name {
    text-align: center;
    color: #ffffff;
    font-size: 30px;
  }
  .report_name {
    font-size: 34px;
    margin-top: 20px;
    font-weight: bold;
  }
  .statistics {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    font-size: 22px;
    color: #ffffff;
    div {
      width: 224px;
      display: flex;
      justify-content: center;
      p {
        display: flex;
        flex-direction: column;
        text-align: left;
        .learn_num {
          font-size: 24px;
          b {
            font-size: 62px;
            margin-right: 8px;
          }
        }
      }
      p:nth-child(2) {
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
      }
    }
    .total_time {
      margin-top: 10px;
    }
    .borders {
      width: 1px;
      height: 90px;
      border-left: 1px dashed;
    }
  }
  .live_detail, .video_detail, .homework_detail, .message_detail, .mock_detail {
    width: 100%;
    padding: 50px 30px 50px 40px;
    background: #ffffff;
    border-radius: 20px;
    margin-top: 30px;
    font-size: 30px;
    .live_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      margin-bottom: 30px;
      .supplementary {
        font-size: 24px;
        font-weight: normal;
        color: #666666;
        margin-left: 20px;
      }
    }
    .right_total {
      margin-left: 70px;
    }
    .godetail {
      width: 80px;
	    height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 20px;
      font-weight: normal;
      color: #999999;
      border: 1px solid #e5e5e5;
      border-radius: 20px;
      img {
        width: 8px;
	      height: 9px;
        margin-left: 10px;
      }
    }
  }
  .live_detail {
    .introduce {
      display: flex;
      align-items: center;
      font-size: 20px;
      border-top: 1px solid #e5e5e5;
      padding-top: 20px;
      color: #666666;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url(./static/images/introduce.png) no-repeat;
        background-size: 100%;
      }
    }
  }
  .info_detail {
    margin-top: 40px;
    text-align: center;
    position: relative;
    img {
      width: 130px;
      height: 130px;
      border-radius: 50%;
      border: 6px solid #ffffff;
    }
    .user_name {
      padding-top: 14px;
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .unaccomplished {
    text-align: center;
    font-size: 26px;
    color: #ffffff;
    box-shadow: 0px 5px 30px 0px  rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    margin-top: 40px;
    padding: 20px 0;
    img {
      width: 27px;
	    height: 26px;
      margin-right: 10px;
    }
  }
  .message_div {
    padding: 30px 0;
    border-bottom: 1px dashed #e5e5e5;
    font-size: 26px;
    line-height: 40px;
    word-break: break-all;
    .message_title {
      font-size: 28px;
      font-weight: bold;
      margin-left: 16px;
      margin-bottom: 10px;
    }
    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
    img {
      width: 100%;
      height: auto;
    }
    .font_bold {
      position: relative;
      span {
        color: #666666;
        font-size: 24px;
        font-weight: normal;
        margin-left: 10px;
      }
      &:before {
        content: '';
        position: absolute;
        top: 6px;
        left: -12px;
        width: 6px;
        height: 26px;
        background: #d44940;
        border-radius: 5px;
      }
    }
  }
  .message_detail {
    .live_title {
      margin: 0;
    }
  }
  .partition_statistics {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .canvas {
      width: 200px;
      font-size: 22px;
      color: #666666;
      background: #f7f7f7;
      border-radius: 15px;
      padding: 20px 0 30px 24px;
      .finish_num {
        color: #d44940;
        font-size: 50px;
        font-weight: bold;
        .hours {
          font-size: 22px;
        }
      }
    }
  }
  .icon {
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
      margin-right: 20px;
    }
  }
}
.screen_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: rgba(0, 0, 0, .7);
  .screen_header {
    position: relative;
    text-align: center;
    height: 92px;
    line-height: 92px;
    font-size: 32px;
    background: #ffffff;
    .goback {
      position: absolute;
      left: 34px;
      img {
        width: 14px;
        height: 28px;
      }
    }
    .title {
      font-weight: bold;
      color: #333333;
    }
    .range {
      position: absolute;
      right: 26px;
      font-size: 28px;
      color: #666666;
      img {
        width: 22px;
        height: 22px;
        margin-left: 14px;
      }
    }
  }
  .screen_option {
    border-top: 1px solid #e6e6e6;
    background: #ffffff;
    padding: 0 30px 30px;
    .screen_time {
      height: 96px;
      line-height: 96px;
      font-size: 26px;
      color: #666666;
      border-bottom: 1px solid #e6e6e6;
      padding-left: 30px;
      .choose_all {
        float: right;
      }
    }
    .check_options p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 90px;
      border-bottom: 1px solid #e6e6e6;
      padding-left: 30px;
      span {
        font-size: 30px;
        font-weight: bold;
      }
      input {
        display: none;
      }
    }
    .radio-name {
      width: 632px;
    }
    .radio-circle {
      display: inline-block;
      width: 28px;
      height: 28px;
      border: 1px solid #cccccc;
      border-radius: 50%;
    }
    .radio-check {
      display: inline-block;
      width: 28px;
      height: 28px;
      border: none;
      background: url(./static/images/check.png) no-repeat;
      background-size: 100%;
    }
    .screen_btn {
      text-align: right;
      margin-top: 20px;
      span {
        display: inline-block;
        width: 130px;
        height: 64px;
        text-align: center;
        line-height: 64px;
        font-size: 26px;
        color: #e60012;
        border: 1px solid #e60012;
        border-radius: 8px;
        margin-left: 30px;
      }
      .determine {
        border: 1px solid #d75b4a;
        color: #ffffff;
        background: linear-gradient(90deg, #d75b4a 0%, #d33f3a 100%), linear-gradient(#666666, #666666);
      }
    }
  }
}
</style>
<style scoped lang="less">
/deep/.van-calendar{
  .van-calendar__body, .van-calendar__header .van-calendar__weekdays{
    width: 100%;
    padding: 0 5% 0;
  }
  .van-calendar__header-title {
    font-weight: bold;
  }
}
/deep/.van-calendar .van-calendar__day {
  height: 75px;
  margin-bottom: 25px;
  >span{
       position: absolute;
       display: none;
       &:nth-child(1){
         display: inline-block;
       }
     }
    &.van-calendar__day--start{
      background-color: #FDE6E8 !important;
     border-radius: 60px 0 0 60px;
     &.add {
      &::before{
          position: absolute;
          top: 10px;
          right: 0;
          bottom: 0;
          left: 24px;
          background-color: #E81929;
          content: '';
          width: 50px;
          height: 50px;
          border-radius: 35px;
          color: #fff;
      }
     }
  }
   &.van-calendar__day--end{
     background-color: #FDE6E8 !important;
     border-radius: 0 60px 60px 0;
    &.add {
      &::before{
          position: absolute;
          top: 10px;
          right: 0;
          bottom: 0;
          left: 24px;
          background-color: #E81929;
          content: '';
          width: 50px;
          height: 50px;
          border-radius: 35px;
          color: #fff;
      }
     }
  }
  .van-calendar__bottom-info{
    color: #333;
    top: -26px;
  }
}
/deep/.van-calendar .van-calendar__day--middle{
  &.sunday{
    &::after{
      border-radius: 60px 0 0 60px;
    }
  }
   &.saturday{
    &::after{
      border-radius: 0 60px 60px 0;
    }
  }
  &.sundayEnd{
     &::after{
      border-radius: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/reports.vue